import { motion, useScroll, useTransform } from "framer-motion";

export default function Nav() {
  const { scrollY } = useScroll();
  const bg = useTransform(
    scrollY,
    [0, 120],
    ["rgba(5,5,5,0)", "rgba(5,5,5,0.72)"]
  );
  const border = useTransform(
    scrollY,
    [0, 120],
    ["rgba(38,38,38,0)", "rgba(38,38,38,1)"]
  );

  return (
    <motion.header
      style={{ backgroundColor: bg, borderBottomColor: border }}
      className="fixed top-0 left-0 right-0 z-50 border-b backdrop-blur-md"
      data-testid="site-nav"
    >
      <div className="mx-auto max-w-[1440px] px-6 md:px-10 h-16 flex items-center justify-between">
        <a
          href="#top"
          className="font-mono-alt text-[11px] tracking-[0.28em] uppercase text-[#f5f5f5]"
          data-testid="nav-logo"
        >
          <span className="text-[#c48a64]">◆</span> The Dual Hub
        </a>
        <nav className="hidden md:flex items-center gap-10 font-mono-alt text-[11px] tracking-[0.24em] uppercase text-[#a3a3a3]">
          <a href="#brands" className="copper-underline" data-testid="nav-brands">Brands</a>
          <a href="#manifesto" className="copper-underline" data-testid="nav-shipping">Shipping</a>
          <a href="#circle" className="copper-underline" data-testid="nav-inner-circle">Inner Circle</a>
        </nav>
        <a
          href="#circle"
          className="hidden md:inline-block font-mono-alt text-[11px] tracking-[0.24em] uppercase text-[#c48a64] copper-underline"
          data-testid="nav-cta"
        >
          Join →
        </a>
      </div>
    </motion.header>
  );
}
